import { render, staticRenderFns } from "./mailling-view.vue?vue&type=template&id=abd236d0&scoped=true"
import script from "./mailling-view.vue?vue&type=script&lang=js"
export * from "./mailling-view.vue?vue&type=script&lang=js"
import style0 from "./mailling-view.vue?vue&type=style&index=0&id=abd236d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd236d0",
  null
  
)

export default component.exports